import React from 'react';
import {isEmpty} from 'lodash';
import CartDisplayTotal from "./CartDisplayTotal";
import CartDisplayShippingTotal from "./CartDisplayShippingTotal";
import TaxExemptIndicator from "../../../Checkout/components/sidebar/TaxExemptIndicator";
import PayLaterIndicator from "./PayLaterIndicator";
import CustomerPoNumberIndicator from "./CustomerPoNumberIndicator";

export default function CartSummaryBox({shoppingCart, ...props}) {
  const {shippingAddress={} } = shoppingCart;

  const showTaxLine  = shoppingCart.effectiveTax  || !isEmpty(shippingAddress);

  return <div className="border border-gray-200 bg-white">
    <h2 className="text-black bg-gray-200 p-2">Cart Summary</h2>

    <div id="cart-summary-table" className="px-2">
      <CartDisplayTotal
        id="regular-subtotal"
        label="Subtotal"
        value={shoppingCart.regularSubtotal}
      />

      <CartDisplayTotal
        id="savings"
        label="Savings"
        optional="true"
        value={-shoppingCart.subtotalSavings}
      />

      <CartDisplayShippingTotal
        id="shipping"
        label="Shipping"
        value={shoppingCart.effectiveShipping}
        shippingAddress={shippingAddress}
      />

      {showTaxLine && <CartDisplayTotal
          id="tax"
          label="Tax"
          value={shoppingCart.effectiveTax}
        />}

      <CartDisplayTotal
        id="total"
        label="Total"
        className="font-bold text-xl"
        value={shoppingCart.effectiveTotal}
      />

    </div>

    <TaxExemptIndicator shoppingCart={shoppingCart}/>
    <PayLaterIndicator shoppingCart={shoppingCart}/>
    <CustomerPoNumberIndicator shoppingCart={shoppingCart}/>
  </div>

}
